@if (mapsLoaded) {
  <google-map
    #googleMap
    [width]="null"
    [height]="null"
    [style.width.px]="width"
    [style.height.px]="height"
  >
    <map-transit-layer />

    @for (c of coordinates; track $index) {
      <map-marker
        [position]="{ lat: c.latitude, lng: c.longitude }"
        [options]="{ icon: c.iconUrl, zIndex: c.zIndex }"
        [clickable]="true"
        (mapClick)="onMarkerClick(c)"
      />

      <map-info-window [options]="{ disableAutoPan: true }">
        <div #content>
          <div #ref class="tooltip"></div>
        </div>
      </map-info-window>

      @if (tooltipTemplate) {
        <myre-tooltip [ref]="ref" [show]="false" [delta]="-33">
          <ng-container
            [ngTemplateOutlet]="tooltipTemplate"
            [ngTemplateOutletContext]="{ $implicit: c }"
          />
        </myre-tooltip>
      }
    }
  </google-map>
}

@if (mapsError) {
  <div myreBanner color="red">
    {{ '_library.map.error' | translate }}
  </div>
}
